export default __webpack_public_path__ + "static/media/oab.189d7db2.png";